export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const MODE = import.meta.env.VITE_MODE ?? "";
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const GOOGLE_RECAPTCHA_V3_SITE_KEY = import.meta.env
  .VITE_GOOGLE_RECAPTCHA_V3_SITE_KEY;
export const GOOGLE_RECAPTCHA_V2_SITE_KEY = import.meta.env
  .VITE_GOOGLE_RECAPTCHA_V2_SITE_KEY;
export const GOOGLE_ANALYTICS_KEY = import.meta.env.VITE_GOOGLE_ANALYTICS_KEY;
export const FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY ?? "";
export const FIREBASE_AUTH_DOMAIN =
  import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "";
export const FIREBASE_PROJECT_ID =
  import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "";
export const FIREBASE_STORAGE_BUCKET =
  import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "";
export const FIREBASE_MESSAGING_SENDER_ID =
  import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "";
export const FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID ?? "";
export const FIREBASE_VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY ?? "";
export const FIREBASE_MEASUREMENT_ID =
  import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? "";
export const BOOKING_CALENDAR_LICENSE_KEY =
  import.meta.env.VITE_BOOKING_CALENDAR_LICENSE_KEY ?? "";
